import { useContext, useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Documents from "./components/screens/Documents";
import Dashboard from "./components/screens/Dashboard";
import Holidays from "./components/screens/Holidays";
import Skills from "./components/screens/Skills";
import HomeOffice from "./components/screens/HomeOffice";
import List from "./components/screens/List";
import HomePage from "./components/screens/HomePage";
import { AuthContext } from "./context/auth-provider";
import { DataContext } from "./context/data-provider";
import AdminDocumentsScreen from "./components/screens/admin/AdminDocumentsScreen";
import AdminSkillsScreen from "./components/screens/admin/AdminSkillsScreen";
import { ROLES } from "./assets/data/roles";
import AdminNationalHolidaysSetter from "./components/screens/admin/AdminNationalHolidaysSetter";
import AdminDashboard from "./components/screens/admin/AdminDashboard";
import { Dna } from "react-loader-spinner";
import GoogleCallback from "./components/screens/GoogleCallback";
import LogIn from "./components/screens/LogIn";
import AdminManageHolidaysScreen from "./components/screens/admin/AdminManageHolidaysScreen";
import locations from "./assets/data/locations";
import ForgotPassword from "./components/screens/ForgotPassword";
import { ChangePassword } from "./components/screens/ChangePassword";
import AdminUsers from "./components/screens/admin/AdminUsers";
import AdminClients from "./components/screens/admin/AdminClients";
import TimelogReport from "./components/screens/admin/TimelogReport";
import AdminNationalHolidaysScreen from "./components/screens/admin/AdminNationalHolidaysScreen";
import TableReport from "./components/screens/admin/TableReport";
import ClientTimelogReport from "./components/screens/admin/ClientTimelogReport";
import AdminOrganizations from "./components/screens/admin/AdminOrganizations";
import OrganizationTimelogReport from "./components/screens/admin/OrganizationTimelogReport";
import NotFoundPage from "./components/screens/NotFoundPage";

const TOKEN_KEY = "token";

function App() {
    const { session, setSession } = useContext(AuthContext);
    const { currentUser } = useContext(DataContext);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) {
            setSession(token);
        }
        setIsLoading(false);
    }, [session]);

    useEffect(() => {
        const foundLink = locations.find(
            (item) => item.link === location.pathname
        );
        if (
            !isLoading &&
            !session &&
            foundLink?.link !== "/" &&
            location.pathname === foundLink?.link
        ) {
            navigate("/");
        }
    }, [isLoading, session, location.pathname, navigate]);

    const isAdmin = currentUser?.role_id === ROLES.ADMIN;
    const isSuperAdmin = currentUser?.role_id === ROLES.SUPER_ADMIN;
    const isClient = currentUser?.role_id === ROLES.CLIENT;
    const anyAdmin = isAdmin || isSuperAdmin;
    const haveUser = currentUser?.role_id !== null;

    if (isLoading || (session && !haveUser)) {
        return (
            <div
                style={{
                    textAlign: "center",
                    marginTop: "25vh",
                }}
            >
                <Dna
                    visible={true}
                    height="100"
                    width="100"
                    ariaLabel="dna-loading"
                    wrapperStyle={{}}
                    wrapperClass="dna-wrapper"
                />
            </div>
        );
    } else {
        return (
            <Routes>
                {session && haveUser ? (
                    <>
                        {anyAdmin ? (
                            <Route path="/" element={<HomePage />}>
                                <Route path="/" element={<AdminDashboard />} />
                                <Route path="/skills" element={<AdminSkillsScreen />} />
                                <Route path="/holidays" element={<Holidays />} />
                                <Route path="/holidays/manageholiday" element={<AdminManageHolidaysScreen />} />
                                <Route path="/holidays/addholiday" element={<AdminNationalHolidaysSetter />} />
                                <Route path="/holidays/nationalholidays" element={<AdminNationalHolidaysScreen />} />
                                <Route path="/documents" element={<AdminDocumentsScreen />} />
                                <Route path="/skills/edit" element={<Skills />} />
                                <Route path="/skills/list" element={<List />} />
                                <Route path="/users/report" element={<TableReport />} />
                                <Route path="/users" element={<AdminUsers />} />
                                <Route path="/timelog/user/:id" element={<TimelogReport />} />
                                <Route path="/timelog/client/:id" element={<ClientTimelogReport />} />
                                <Route path="/clients" element={<AdminClients />} />
                                <Route path="/organizations" element={<AdminOrganizations />} />
                                <Route path="/timelog/organization/:id" element={<OrganizationTimelogReport />} />
                                <Route path="/home_office" element={<HomeOffice />} />
                                <Route path="*" element={<NotFoundPage />} />
                            </Route>
                        ) : isClient ? (
                            <Route path="/" element={<HomePage />}>
                                <Route path="/" element={<ClientTimelogReport />} />
                                <Route path="*" element={<NotFoundPage />} />
                            </Route>
                        ) : 
                        <Route path="/" element={<HomePage />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/skills/list" element={<List />} />
                            <Route path="/holidays" element={<Holidays />} />
                            <Route path="/documents" element={<Documents />} />
                            <Route path="/skills" element={<Skills />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                        }
                    </>
                ) : (
                    <>
                        <Route path="/" element={<LogIn />} />
                        <Route path="/auth/google" element={<GoogleCallback />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/change-password" element={<ChangePassword />} />
                    </>
                )}
                <Route path="/timelog/client/:id" element={<ClientTimelogReport />} />
            </Routes>
        );
    }
}

export default App;
